export const RouterErrorHandler = (error: any): any => {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error?.message)) {
        if (confirm($localize`:Alert|Messages@@new version:New version available. Load new version?`)) {
            window.location.reload();
        }
    }
}
